import { Building2Icon, CreditCardIcon, LayoutDashboardIcon, RefreshCwIcon, ScrollTextIcon } from "lucide-react";
import { useSession } from "@/app/session";
import { FullScreenLoadingState } from "@/components/data/loading-state";
import type { NavEntry } from "@/components/layout/nav-items";
import { ShellFrame } from "@/components/layout/shell-frame";

const PLATFORM_NAV: NavEntry[] = [
  { kind: "link", label: "Dashboard", href: "/", icon: LayoutDashboardIcon },
  { kind: "link", label: "Organizations", href: "/tenants", icon: Building2Icon },
  { kind: "link", label: "Card usage", href: "/card-usage", icon: CreditCardIcon },
  { kind: "link", label: "Sync log", href: "/sync-log", icon: RefreshCwIcon },
  { kind: "link", label: "Audit log", href: "/audit", icon: ScrollTextIcon },
];

/** The platform console frame. Only a signed-in platform admin gets past this. */
export function PlatformShell() {
  const session = useSession();
  if (session.status !== "super_admin") {
    return <FullScreenLoadingState />;
  }
  return <ShellFrame items={PLATFORM_NAV} userLabel="Platform admin" userEmail={session.email} />;
}
